const updates = [
  {
    time: '刚刚',
    tag: '突发',
    title: '某知名女星被拍到深夜出入整形医院，疑似进行面部调整',
  },
  {
    time: '18分钟前',
    tag: '新料',
    title: '热门网剧男主被曝与多名女粉丝有不正当关系',
  },
  {
    time: '32分钟前',
    tag: '更新',
    title: '昨日综艺翻车事件后续：涉事嘉宾发文道歉，节目组宣布整改',
  },
  {
    time: '1小时前',
    tag: '独家',
    title: '某顶流男团成员私下聚会照片流出，场面引争议',
  },
  {
    time: '2小时前',
    tag: '追踪',
    title: '知名导演潜规则事件持续发酵，又有三位当事人出面作证',
  },
  {
    time: '3小时前',
    tag: '爆料',
    title: '头部网红公司内部聊天记录泄露，揭露数据造假产业链',
  },
  {
    time: '5小时前',
    tag: '热点',
    title: '某国际品牌中国区代言人突然更换，原代言人团队拒绝回应',
  },
  {
    time: '7小时前',
    tag: '深扒',
    title: '娱乐圈"隐形大佬"身份曝光，名下关联多家艺人经纪公司',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">最新动态</h2>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200 hidden md:block"></div>
          <div className="space-y-0">
            {updates.map((item, idx) => (
              <div
                key={idx}
                className="relative flex gap-4 md:gap-6 py-4 first:pt-0 last:pb-0 group cursor-pointer"
              >
                <div className="relative z-10 flex-shrink-0 hidden md:flex">
                  <div className="w-10 h-10 rounded-full border-2 border-background-200 bg-background-50 flex items-center justify-center group-hover:border-primary-400 transition-colors">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                </div>
                <div className="flex-1 min-w-0 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 group-hover:border-primary-200/60 transition-all duration-300">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-snug group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}